import axios from 'axios'

export const telecoming = {
  namespace: true,
  state: {
    carrier: {},
    mobileData: {}
  },

  mutations: {
    setCarrier(state, carrier) {
      state.carrier = carrier
    },
    setMobileData(state, mobileData) {
      if (mobileData) {
        state.mobileData = mobileData
      }
    }
  },

  actions: {
    async getCarrier({ commit }, payload) {
      await axios
        .get('/carrier-detection-url/', {
          params: payload
        })
        .then(res => {
          commit('setCarrier', res.data)
        })
        .catch(res => {
          if (typeof window !== 'undefined') {
            if (typeof CustomEvent === 'function') {
              var event = new CustomEvent('showError', {
                detail: {
                  textI18N: 'error.title',
                  error: res
                }
              })
              window.dispatchEvent(event)
            }
          }
        })
    },
    async getMobileData({ commit }, data) {
      commit('setMobileData', data)
    }
  }
}
